import React, { FunctionComponent, useState, CSSProperties, ChangeEvent, MouseEvent } from 'react';
import { Presentation } from './presentation';
import { MessageTemplate } from '../../../types/messageTemplate';

type Props = {
  templates: MessageTemplate[];
  targetSpan: string;
  hoverStyle: CSSProperties;
  dustboxStyle: CSSProperties;
  onClicked: () => void;
  handleFetchedTemplate: (event: MouseEvent<HTMLSpanElement>) => void;
  handleDeletedTemplate: (event: MouseEvent<HTMLElement>) => void;
};

export const Component: FunctionComponent<Props> = ({
  templates,
  targetSpan,
  hoverStyle,
  dustboxStyle,
  onClicked,
  handleFetchedTemplate,
  handleDeletedTemplate,
}) => {
  const [filterText, setFilterText] = useState('');

  const handleFilterChange = (event: ChangeEvent<HTMLInputElement>) => {
    setFilterText(event.target.value);
  };

  const filteredTemplates = templates.filter(template =>
    template.title?.toLowerCase().includes(filterText.toLowerCase())
  );

  return (
    <Presentation
      filterText={filterText}
      onFilterChange={handleFilterChange}
      templates={filteredTemplates}
      targetSpan={targetSpan}
      hoverStyle={hoverStyle}
      dustboxStyle={dustboxStyle}
      onClicked={onClicked}
      handleFetchedTemplate={handleFetchedTemplate}
      handleDeletedTemplate={handleDeletedTemplate}
    />
  );
};
